import breakpoints from '../utils/breakpoints';
var micrositeTheme = {
    breakpoints: breakpoints,
};
export default micrositeTheme;
